$(document).ready(function(){
	// Request a Repair, Request RA, Request SWAP, Dispatch portal request repair
	// common step controll script
	if(document.querySelectorAll('.step-cluster').length == 0) return false;

	var step = {
		wrap: document.getElementsByClassName("step-in-form"),		
		// 20200323 START 구유정 || step.countrycode 추가
		countrycode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
		// 20200323 END 구유정 || step.countrycode 추가

		// 20200325 START 구유정 || step.pageType 추가, PJTEXTENDEDWTY-4 
		pageType: document.querySelector('.step-in-form.request-repair') ? document.querySelector('.step-in-form.request-repair').getAttribute("data-page-type") : '',
		// 20200325 END 구유정 || step.pageType 추가, PJTEXTENDEDWTY-4

		// 20200325 START 구유정 || step.pageType 추가
		infoInput : $("#stepContactInformation").find("input[type='text'],[type='email'],[type='tel'],[type='number']"), // LGECS-329
		infoInput_del : null,
		infoInputisInvailStep : null,
		infoInput_idx : 0,
		noticeBoxTimeId : null, // LGEIN-839 (In법인 noticeBox setTimeOut ID 값)
		/* LGEEG-142 Start */
		// LGEEG-274 Start : EG법인 clusters 정보 null 처리(step 이용안함)
		els: {
			clusters: (this.countrycode == 'eg_en' || this.countrycode =='eg_ar') && (this.pageType == 'install' || this.pageType == 'common') ? null : document.querySelectorAll('.step-cluster'), //LGEEG-142
			completeCluster: document.querySelector('.review-submit'),
			compleatForm: document.getElementById('stepCompleatForm'),
			$modify: $('.btn-modify')
		},
		/* LGEEG-142 End */
		// LGEEG-274 End
		// 20200325 END 구유정 || step.pageType 추가

		init: function(){
			var _this = this,
				_els = this.els;

			for (var i = 0; i < _els.clusters.length; i++) {
				var _cluster = _els.clusters[i];
				_cluster.setAttribute('data-idx', i);
			};

			var $para = $('#step_submit_error').find('.content-paragraph');
			$('#step_submit_error').attr('data-default-msg', $para.text());

			// 20200527 START 구유정 || #valid_error 추가
			!$("#valid_error").length && $('#step_submit_error').clone(true).prop("id", "valid_error").insertAfter( $(".modal").last() );
			// 20200527 END 구유정 || #valid_error 추가

			// Select by Product Category select box scroll 적용
			chosenScrollInit();

			_this.addEvent();
			
			// LGECS-329 start
			for( var i=0; i<step.infoInput.length; i++){
				$(step.infoInput[i]).data("orgvalue",step.infoInput[i].value);
			}
			// LGECS-329 end
			// LGEIN-839 Start : 페이지 로드 3분 후, notice-box div 태그에 show 클래스 추가 
			if(step.countrycode == 'in') {
				step.noticeBoxTimeId = setTimeout(function() {
					$('.step-cluster .notice-box').addClass('show');
					clearTimeout(step.noticeBoxTimeId);
				}, 180000)
			}
			// LGEIN-839
		},
		setConfirmedStep: function(_form, _del, isInvailStep){
			var _rev;
			if(!_del.querySelector('.repair-content-inner')){
				_rev = _del.querySelector('.complete-announcement');
			}else{
				_rev = _del.querySelector('.repair-content-inner.active .complete-announcement');
			}

			if(!_rev) return false;

			var _outputAreas = _rev.querySelectorAll('.js-linked-input'),
				_outputArray = _rev.querySelectorAll('.js-linked-array'),
				_outputImg = _rev.querySelectorAll('.js-linked-img'),
				_outputAnchor = _rev.querySelectorAll('.js-linked-anchor'),
				_outputText = _rev.querySelectorAll('.js-linked-text'),
				_outputData = _rev.querySelectorAll('.js-linked-data'),
				_nextCluster,
				idx = Number(_del.getAttribute('data-idx'));

			// setting review Area
			for (var i = 0; i < _outputAreas.length; i++) {
				var _output = _outputAreas[i],
					targetName = _output.getAttribute('data-linked-name'),
					_target = _form[targetName];
				if(_target) {
					var val = _target.value;

					// 20200413 START 구유정 || _target.length 여러개일때 추가(개발요청)
					if(_target.length > 1){
						$(_target).each(function(){
							if($(this).parent(".field-block").is(":visible")){
								_target = $(this).get(0);
								val = _target.value;
							}
						})
					}
					// 20200413 END 구유정 || _target.length 여러개일때 추가(개발요청)

					if($(_target).is('select')) {
						var currentOption = _target.querySelector('option[value="'+_target.value+'"]');
						val = _target.value != '' ? $(currentOption).text() : '';
						if(val == '' && !$(_target).is(':visible')) {
							val = false;
						}
					}else if($(_target).is('textarea')){
						val = val.replace(/(?:\r\n|\r|\n)/g, '<br />');
					}else if(_target[0]){
						if(_target[0].type == 'radio' || _target[0].type == 'checkbox') {
							val = $(_target).filter(':checked').attr('data-text');
							val = (val == '' || !val) ? $(_target).val() : val;
						}else {
							val = $(_target).filter(':visible').val();
							// val = _target[0].value;
						}
					}

					// field masking
					var length = _output.getAttribute('data-masking-length');
					if(length) {
						length = !isNaN(length) ? Number(length) : 99;
						length = length > 0 ? length : length;
						val = val.substring(0, length) + '********';
					}

					if(val) val = xssfilter(val, true);
					$(_output).html(val);

					// empty field case
					if(val == '') {
						if($(_output).closest('dl').find('.js-linked-input').length > 0) {
							var checkEmpty = 0;
							$(_output).closest('dl').find('.js-linked-input').each(function(){
								if($(this).text() != '') {
									checkEmpty ++;
								}
							});

							if(checkEmpty == 0) {
								$(_output).closest('dl').hide();
							}else {
								$(_output).closest('dl').removeAttr('style');
							}
						}
					}else {
						$(_output).closest('dl').removeAttr('style');
					}
				}
			};

			// be change anchor
			if(_outputAnchor.length >= 0) {
				for (var i = 0; i < _outputAnchor.length; i++) {
					var _output = _outputAnchor[i],
					targetName = _output.getAttribute('data-linked-anchor'),
					_targets = _del.querySelector(targetName);
					
					// 20200323 START 구유정 || if(!_targets) continue 추가
					if(!_targets) { continue };
					// 20200323 END 구유정 || if(!_targets) continue 추가
					
					_output.setAttribute('href', _targets.getAttribute('href'));
					if($(_targets).hasClass('disabled')) {
						$(_output).addClass('disabled');
					}else {
						$(_output).removeClass('disabled');
					}
				}
			}

			// be change images
			if(_outputImg.length >= 0) {
				for (var i = 0; i < _outputImg.length; i++) {
					var _output = _outputImg[i],
					targetName = _output.getAttribute('data-linked-img'),
					_targets = _del.querySelector(targetName);
					
					// 20200323 START 구유정 || if(!_targets) continue 추가
					if(!_targets) { continue };
					// 20200323 END 구유정 || if(!_targets) continue 추가
					
					_output.setAttribute('src', _targets.getAttribute('src'));
					_output.setAttribute('alt', _targets.getAttribute('alt'));
					// LGEEG-79 Start
					if(step.countrycode == "eg_en" || step.countrycode == "eg_ar"){
						if($('.model-view-image').css("display") == "none"){
							_output.setAttribute('src',"/lg5-common-gp/images/support/icons/no-image.svg");
							_output.setAttribute('alt',"No image");
						}
					}
					// LGEEG-79 End
				}
			}

			// change text
			if(_outputText.length >= 0){
				for (var i = 0; i < _outputText.length; i++) {
					var _output = _outputText[i],
					targetName = _output.getAttribute('data-linked-text'),
					_targets = _del.querySelector(targetName);
					
					// 20200323 START 구유정 || if(!_targets) continue 추가
					if(!_targets) { continue };
					// 20200323 END 구유정 || if(!_targets) continue 추가

					$(_output).text($(_targets).text());
				}
			}

			// if several value type
			if(_outputArray.length >= 0) {
				for (var j = 0; j < _outputArray.length; j++) {
					var _output = _outputArray[j],
						targetName = _output.getAttribute('data-linked-array'),
						_targets = _form.querySelectorAll(targetName),
						result = [];

						for (var k = 0; k < _targets.length; k++) {
							var _value = _targets[k].value;
							if(_value && _value != '') {
								result.push(_targets[k].value);
							}
						}

					if(result.length > 0) {
						$(_output).text(result.join(', '));
						$(_output).closest('dl').removeAttr('style');
					}else {
						$(_output).closest('dl').hide();
					}
				};
			}

			// change data
			if(_outputData.length >= 0){
				for (var i = 0; i < _outputData.length; i++) {
					var _output = _outputData[i],
					targetName = _output.getAttribute('data-linked-data'),
					joinString = _output.getAttribute('data-join-string') || ", <br />",
					_targets = _del.querySelectorAll( "["+ targetName +"]" );

					if(_targets.length == 1) {
						$(_output).text($(_targets).attr(targetName));
					} else {
						for(var i=0, valueArr=[]; i<_targets.length; i++) {
							valueArr.push($(_targets[i]).attr(targetName));
						}
						$(_output).html(valueArr.filter(function(arr){ return arr }).join(joinString));
					}
				}
			}

			// Model number of the next steps (input, review area)
			$('[data-repair-info]').each(function(){
				var $this = $(this);
				switch ($this.attr('data-repair-info')) {
					case "productModelNumber":
						var $searchInput = $("#step_select_product form.search-common input[name='search']");
						$this.text($searchInput.val());
						break;
					case "serialModelNumber":
						var $modelInput = $("#step_select_product input.modelNumber_hidden[name='modelNum']");
						$this.text($modelInput.val());
						break;
					// 추가 예정
					// default:
					// 	break;
				}
			})
			
			// LGECS-329 start
			var chkOrgVal = 0;
			step.infoInput_del = _del;
			step.infoInputisInvailStep = isInvailStep;
			step.infoInput_idx = idx;
			if( $(_del).prop("id") == "step_contact_information" && step.infoInput.length > 0){
				if( !$("#checkUpdateInfo").prop("checked") && $("#LoginYn").val() == "Y"){
					for( var i=0; i<step.infoInput.length; i++){
						if( step.infoInput[i].value != $(step.infoInput[i]).data("orgvalue")){
							chkOrgVal++;
							break;
						}
					}
				}
			}
			if( chkOrgVal > 0){
				step.infoInput_del = _del;
				step.infoInputisInvailStep = isInvailStep;
				step.infoInput_idx = idx;
					
				$('#info_modify_confirm').modal('show');
				
			}else{
				step.infoNextStep();
			}
			// LGECS-329 end
			
			var $stepInForm = $('.step-in-form');
			if($stepInForm.hasClass('request-repair')) {
				// request a repair
				if(parseInt($(_nextCluster).attr('data-idx'))==1) {
					adobeTrackEvent('cs-step-request-repair', {cs_product_name : getStepProductCode(), page_event : {repair_product_request_step2 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==2) {
					adobeTrackEvent('cs-step-request-repair', {cs_product_name : getStepProductCode(), page_event : {repair_product_request_step3 : true}});
				}
			} else if($stepInForm.hasClass('request-ra')) {
				// request ra
				if(parseInt($(_nextCluster).attr('data-idx'))==1) {
					adobeTrackEvent('cs-step-request-ra', {cs_product_name : getStepProductCode(), page_event : {request_ra_step2 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==2) {
					adobeTrackEvent('cs-step-request-ra', {cs_product_name : getStepProductCode(), page_event : {request_ra_step3 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==3) {
					adobeTrackEvent('cs-step-request-ra', {cs_product_name : getStepProductCode(), page_event : {request_ra_step4 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==4) {
					adobeTrackEvent('cs-step-request-ra', {cs_product_name : getStepProductCode(), page_event : {request_ra_step5 : true}});
				}
			} else if($stepInForm.hasClass('request-swap')) {
				// request swap
				if(parseInt($(_nextCluster).attr('data-idx'))==1) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step2 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==2) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step3 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==3) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step4 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==4) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step5 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==5) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step6 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==6) {
					adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_step7 : true}});
				}
			} else if($stepInForm.hasClass('request-dispatch')) {
				// request dispatch
				if(parseInt($(_nextCluster).attr('data-idx'))==1) {
					adobeTrackEvent('cs-step-request-dispatch', {cs_product_name : getStepProductCode(), page_event : {dispatch_portal_repair_request_step2 : true}});
				} else if(parseInt($(_nextCluster).attr('data-idx'))==2) {
					adobeTrackEvent('cs-step-request-dispatch', {cs_product_name : getStepProductCode(), page_event : {dispatch_portal_repair_request_step3 : true}});
				}
			}
			
			
		},
		infoNextStep: function(){
			$(step.infoInput_del).addClass('passed');
			$('.step-cluster').removeClass('closed');
			
			var _delTop;

			if(!step.infoInputisInvailStep) {
				// setting next Step Cluster
				if(step.els.clusters.length-1 != step.infoInput_del.getAttribute('data-idx')) {
					_nextCluster = step.els.clusters[(step.infoInput_idx+1)];
				}else if(step.els.clusters.length-1 == step.infoInput_del.getAttribute('data-idx')) {
					_nextCluster = step.els.completeCluster;
					$('.step-submit').removeClass('active');
					// if this cluster is last step
				}
				
				if($(_nextCluster).is('.disabled')) {
					_nextCluster = step.els.clusters[(step.infoInput_idx+2)];
				}

				$(_nextCluster).addClass('active').attr('tabindex', 0).focus();
				// LGEEG-79 Start
				if(step.countrycode == "eg_en" || step.countrycode == "eg_ar"){
					if(step.pageType == "install"){
						if($(_nextCluster).attr("id") == "step_contact_information"){
							var _nextNextCluster =step.els.clusters[(step.infoInput_idx+2)];
							$(_nextNextCluster).addClass('active').attr('tabindex', 0).show();
						}
					}
				}
				// LGEEG-79 End
				
				// LGEIN-839 Start : 각 스텝별로 submit 버튼 클릭 후 submit:confirmed 될 경우, 다음 단계에서 3분 지나면 notice-box 영역 표출
				if(step.countrycode == 'in') {
					clearTimeout(step.noticeBoxTimeId);
					$(_nextCluster).find('.notice-box').removeClass('show');
					step.noticeBoxTimeId = setTimeout(function() {
						// $('.step-cluster .notice-box').addClass('show');
						$(step.infoInput_del).find('.notice-box').addClass('show');
						$(_nextCluster).find('.notice-box').addClass('show');
						clearTimeout(step.noticeBoxTimeId);
					}, 180000) 
				}
				// LGEIN-839 End
				
					//.find('input, textarea, select').eq(0).focus();
				$(_nextCluster.querySelector('form')).trigger('activate', [_nextCluster]);
				
				_delTop = $(_nextCluster).offset().top;
			}else {
				_delTop = $(step.infoInput_del).offset().top;
			}
			
			$('html, body').animate({
				scrollTop: _delTop
			});
		},
		resetStepForm: function(){
			// 20200323 START 구유정 || Phase 4 CN reset 관련 추가
			/*LGEIN-929 start*/
			if(step.countrycode != "cn" && step.countrycode != "in"){
				// GP
				$(step.els.clusters).removeClass("active passed closed"); // step1, step2, step3, step4
				$(step.els.completeCluster).removeClass("active"); // step5
			}
			// 20200325 START 구유정 || Phase 4 CN pageType 구분 추가
			if(step.countrycode == "cn") {
				// CN
				if(step.pageType == "allStep"){
					$(step.els.clusters).removeClass("passed closed").addClass("active"); // step1, step2, step3, step4
					$(step.els.completeCluster).removeClass("active"); // step5
				}else{
					$(step.els.clusters).removeClass("active passed closed"); // step1, step2, step3, step4
					$(step.els.completeCluster).removeClass("active"); // step5
				}
			}else if(step.countrycode == "in") {
				$(step.els.clusters).removeClass("passed closed").addClass("active"); // step1, step2, step3, step4
			}
			/*LGEIN-929 End*/
			// 20200325 END 구유정 || Phase 4 CN pageType 구분 추가
			// 20200323 END 구유정 || Phase 4 CN reset 관련 추가

			$("form#stepSelectProduct").trigger("selectProduct:reset"); // "reset" step1
			$("form#stepProductIssue").trigger("productIssue:reset"); // "reset" step2
			$("form#repairTypeForm").trigger("repairType:reset"); // "reset" step3
			$("form#contactInformationForm").trigger("contactInformation:reset"); // "reset" step4

			$(step.els.clusters).first().addClass("active"); // "addClass" step1
		},
		addEvent: function(){
			var _els = this.els,
				_this = this;
			
			// step cluster only
			$(_els.clusters).on({
				'submit:confirmed': function(e, isInvailStep){
					var _del = e.delegateTarget,
						_form = e.currentTarget;
					// Need to check the branch point Step(ESP, No ESP or ship in, in home) later
					// step cluster length and data-idx should be redefined whenever change the branch point

					// console.log('submit:confirmed');
					_els.$modify.removeAttr('style');
					_this.setConfirmedStep(_form, _del, isInvailStep);
				}
			}, '.js-step-form');
			$(_els.clusters).on({
				submit: function(e){
					e.preventDefault();
					$(this).trigger('submit:confirmed');
				}
			}, '.js-simple-step-form');
			$(_els.clusters).on({
				click: function(e){
					e.preventDefault();
					var $targetCluster = $(e.currentTarget.getAttribute('href'));

					if($targetCluster.is('#step_enhanced_service')) {
						var _modal = $('#modify_confirm');
						if(_modal.get(0)) {
							$('#modify_confirm').modal('show');
						}
					}else {
						$targetCluster.find('.btn-modify').hide();	//  LGECS-357
						$targetCluster.removeClass('passed closed');	// LGECS-357
						$(_els.completeCluster).removeClass('active');
						$('html, body').animate({
							scrollTop: $targetCluster.offset().top
						});

						if($('#myProductList').length>0 && $('#myProductList').is(':visible')) {
							setTimeout(function(){
								$('#myProductList .items').slick('setPosition');
							}, 80);
						}

						// 20200323 START 구유정 || Phase 4 CN edit 관련 추가
						if(step.countrycode != "cn"){
							$targetCluster.siblings('.step-cluster').addClass('closed');
							$targetCluster.nextAll('.step-cluster').removeClass('active passed');
							
							// LGEEG-79 Start
							if(step.countrycode == "eg_en" || step.countrycode == "eg_ar"){
								if(step.pageType == "install"){
									$('#step_repair_type').hide();
								}
							}
							// LGEEG-79 End
						}
						
						// 20200325 START 구유정 || Phase 4 CN pageType 구분 추가
						if(step.countrycode == "cn"){
							// CN
							if(step.pageType == "allStep"){
								$(step.els.clusters).removeClass("passed closed").addClass("active");
								$(step.els.completeCluster).removeClass("active");
							}else{
								$targetCluster.siblings('.step-cluster').addClass('closed');
								$targetCluster.nextAll('.step-cluster').removeClass('active passed');
							}
						}
						// 20200325 END 구유정 || Phase 4 CN pageType 구분 추가
						// 20200323 END 구유정 || Phase 4 CN edit 관련 추가
					}
				}
			}, '.btn-modify');
			$('#modify_confirm').on({
				click: function(e){
					e.preventDefault();
					// reset All forms

					_els.$modify.removeAttr('style');
					$('form').trigger('reset');
					$('select').trigger('chosen:updated');
					$('#modify_confirm').modal('hide');
					$('.no-model-select').show().siblings().hide();
					$('.field-block').removeClass('error');

					$(_els.clusters).removeClass('active passed').eq(0).addClass('active');
					$(_els.completeCluster).removeClass('active');
				}
			}, 'button[type="submit"]');
			
			// LGECS-329 start
			$('#info_modify_confirm').on({
				click: function(e){
					e.preventDefault();
					if( $("#checkUpdateInfo").length > 0){
						$("#checkUpdateInfo").prop("checked",true);
					}else if( $("#callAccountCheck").length > 0){
						$("#callAccountCheck").prop("checked",true);
					}
					$("#info_modify_confirm").modal('hide');
					
					step.infoNextStep();
				}
			}, 'button[type="submit"]');
			
			$('#info_modify_confirm').on({
				click: function(e){
					e.preventDefault();
					if( $("#checkUpdateInfo").length > 0){
						$("#checkUpdateInfo").prop("checked",false);
					}else if( $("#callAccountCheck").length > 0){
						$("#callAccountCheck").prop("checked",false);
					}
					$('#info_modify_confirm').modal('hide');
					
					step.infoNextStep();
				}
			}, 'button[type="button"]');
			// LGECS-329 end

			// compleat Submit
			$(_els.compleatForm).on({
				submit: function(e){
					e.preventDefault();
					var params = new FormData();
					
					if($('#step_submit_ready').length > 0) {
						$('#step_submit_ready').modal('hide');
					}
					
					// 20200527 START 구유정 || levant_ar, levant_en case 추가
					if(step.countrycode == "levant_ar" || step.countrycode == "levant_en"){
						var $reservationWrap = $("#reservationSelectForm"); // call-appointment step3
						var $reservationArea = $reservationWrap.find(".reservation-schedule");

						if($reservationWrap.length && $reservationArea.css('display') == 'none'){
							var msg = $reservationArea.find("#reservationDate").siblings(".error-msg").find(".required").text();

							$(".modal[id$='submit-confirm']").modal("hide");
							$("#valid_error").modal('show').find('.content-paragraph').html(msg);

							return;
						}
					}
					// 20200527 END 구유정 || levant_ar, levant_en case 추가

					for (var i = 0; i < _els.clusters.length; i++) {
						var _form = _els.clusters[i].querySelectorAll('.js-step-form'),
							curParams = $(_form).serializeArray();
						// params.push(curParams);

						for (var k = 0; k < _form.length; k++) {
							var _curForm = _form[k],
								$files = $(_curForm).find('input:file');

							for (var j = 0; j < curParams.length; j++) {
									fieldValue = _curForm[curParams[j].name].value;

								if(_curForm[curParams[j].name].length > 0) {
									var options = _curForm[curParams[j].name];
										fieldValue = [];
									if(options.type !== undefined) {
										if(options.type.indexOf('select') >= 0) {
											fieldValue = options.options[options.selectedIndex].value;
											// console.log(fieldValue);
										}
									}else {
										for (var optionIdx = 0; optionIdx < options.length; optionIdx++) {
											var currentOpt = options[optionIdx];
											if(currentOpt.checked == true) {
												fieldValue += currentOpt.value;
											}
										}
									}
									
								}
								var $currentForm = $(_curForm);
								var $input = $currentForm.find('[name=' + curParams[j].name + ']');
								var inputType = $input.get(0).type;
								// contact information only visible input add

								if ($input.length > 1 && inputType != 'radio') {
									$input.each(function( index ){
										// 20200423 START 구유정 || step 별 param 중복 조건 변경
										if($currentForm.attr("id") == "repairTypeForm"){
											// use: request repair (step3)
											var repairContent = $(this).closest('.repair-content-inner');
											if ( repairContent.hasClass('active')){
												params.append(curParams[j].name, $(this).val());
											}
										}else if($currentForm.attr("id") == "contactInformationForm"){
											// use: request repair (step4), call appointment (step4)
											var optionList = $(this).closest('.option-list');
											if ( optionList.css('display') == 'block' && optionList.parent().css('display') == 'block' ){
												params.append(curParams[j].name, $(this).val());
											}
										}else{
											// request repair, call appointment (another step)
											if($(this).val()){
												params.append(curParams[j].name, $(this).val());
											}
										}
										// 20200423 END 구유정 || step 별 param 중복 조건 변경
									});
								} else {
									params.append(curParams[j].name, fieldValue);
								}
							}

							if($files.length > 0) {
								for (var j = 0; j < $files.length; j++) {
									var _file = $files.eq(j).get(0);
									if(_file.files[0]) {
										// console.log(_file.name, _file.files[0]);
										params.append(_file.name, _file.files[0], _file.files[0].name);
									}
								}
							}
						}
					};
					
					// LGEGMC-5323 start
					if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y"){
						params.append("recaptchaPageType", $("#recaptchaPageType").val());
						params.append("verifyKey", $("#verifyKey").val());
					}
					// LGEGMC-5323 end
					
					//LGCOMMON-9124 START
					var sourcecode = $("#sourcecode").val();
					if(sourcecode != null && sourcecode != ""){
						params.append("sourcecode", sourcecode);
					}
					//LGCOMMON-9124 END

					var url = this.getAttribute('data-action');
					// var param = xssfilter(params);
					var methodType = $(this).data('ajaxMethod');

					// $.ajax({
					// 	url: url,
					// 	// type: methodType?methodType:'get',
					// 	type: 'post',
					// 	processData: false,  // file전송시 필수
					// 	contentType: false,  // file전송시 필수
					// 	data: params
					// })

					$('body').trigger('ajaxLoadBefore');
					
					// button add attr "disabled"
					$(_els.compleatForm).find("button.btn").attr("disabled", "disabled");

					ajax.noCacheCall(url, params, 'json', function(data){
						$('body').trigger('ajaxLoadEnd');
						var $submitModal = $(".modal[id$='submit-confirm']");

						// 20200520 START 구유정 || data.result "success" 조건 추가 (REDMINE #7538)
						if($('.step-in-form').hasClass('request-dispatch')) {
							// dispatch portal
							if(data.result == false && data.error && data.step_schedule_error){
								$submitModal.modal('hide');
								$('#step_schedule_error').modal('show').find('.content-paragraph').html(data.step_schedule_error);
								$(_els.compleatForm).find("button.btn").removeAttr("disabled"); // button remove attr "disabled"
							} else if(data.result == false && data.error) {
								$submitModal.modal('hide');
								$('#step_schedule_error').modal('show').find('.content-paragraph').html(data.error);
								$(_els.compleatForm).find("button.btn").removeAttr("disabled"); // button remove attr "disabled"
							}else if(data.result == false || data.result !== true){
								var $error = $('#step_submit_error');
								if(data.msg && data.msg != '') {
									$error.find('.content-paragraph').text(data.msg);
								}else {
									$error.find('.content-paragraph').text($error.attr('data-default-msg'));
								}
								$submitModal.modal('hide');
								$(_els.compleatForm).find("button.btn").removeAttr("disabled"); // button remove attr "disabled"
								$error.modal('show');
							} else {
								// request dispatch (adobe)
								adobeTrackEvent('cs-step-request-dispatch', {cs_product_name : getStepProductCode(), page_event : {dispatch_portal_repair_request_complete : true}});

								var submitData = JSON.stringify(data.submitData);
								$(e.currentTarget).append('<input type="hidden" name="data" value="">');
								e.currentTarget.data.value = submitData;
								e.currentTarget.submit();
							}
						} else {
							if(data.result == false && data.error){
								$submitModal.modal('hide');
								$(_els.compleatForm).find("button.btn").removeAttr("disabled"); // button remove attr "disabled"
								for(var key in data.error) {
									$('#'+key).modal('show');
								}
							}else if(data.result == false || data.result !== true){
								var $error = $('#step_submit_error');
								if(data.msg && data.msg != '') {
									$error.find('.content-paragraph').text(data.msg);
								}else {
									$error.find('.content-paragraph').text($error.attr('data-default-msg'));
								}
								$submitModal.modal('hide');
								$(_els.compleatForm).find("button.btn").removeAttr("disabled"); // button remove attr "disabled"
								$error.modal('show');
							}else {
								var $stepInForm = $('.step-in-form');
								if($stepInForm.hasClass('request-repair')) {
									// request a repair (adobe)
									adobeTrackEvent('cs-step-request-repair', {cs_product_name : getStepProductCode(), page_event : {repair_product_request_complete : true}});
								} else if($stepInForm.hasClass('request-ra')) {
									// request ra (adobe)
									adobeTrackEvent('cs-step-request-ra', {cs_product_name : getStepProductCode(), page_event : {request_ra_complete : true}});
								} else if($stepInForm.hasClass('request-swap')) {
									// request swap (adobe)
									adobeTrackEvent('cs-step-request-swap', {cs_product_name : getStepProductCode(), page_event : {request_swap_complete : true}});
								}
								// LGEGMC-3469, LGEGMC-5141 Start
								if( (salesForceUseFlag || salesForceRunV2) && data.submitData.pageType !== 'install' && USER_ID !== 'guest'){
									const eventName = salesForceRunV2 ? 'CsRepairClicked' : 'ecrmCsRequestRepairClicked';
									console.log(eventName + ' insert');

									SalesforceInteractions.sendEvent({
										interaction: {
											name: eventName,
											eventType: eventName,
											ecrmUserId: USER_ID,
											ecrmLocaleCode: COUNTRY_CODE,
											ecrmProductId: autoNvl( $('input[name="modelCsSalesCode"]').val() )
										}
									})
								};
								// LGEGMC-3469, LGEGMC-5141 End 

								var submitData = JSON.stringify(data.submitData);
								$(e.currentTarget).append('<input type="hidden" name="data" value="">');
								e.currentTarget.data.value = submitData;
								e.currentTarget.submit();
							}
						}
						// 20200520 END 구유정 || data.result "success" 조건 추가 (REDMINE #7538)

					}, methodType, 'body', false);
				}
			});
			$('.dispatch-portal-form').on({
				click: function(e){
					e.preventDefault();
					$('#step_submit_ready').modal('show');
				}
			}, 'button[type="submit"]');

			// step content reset
			$(step.wrap).on({
				"allStep:reset": function(e){
					e.preventDefault();
					step.resetStepForm();
				}
			});
			//*LGEBR-801 start*//
			$(step.els.completeCluster).on("click", "a.repairSubmit", function(e){
				$(_els.compleatForm).submit();
			})
			//*LGEBR-801 end*//
		}
	}

	var toggleRadio = {
		$el: $("input[type='radio'][data-active-target], input[type='radio'][data-required-target]"),
		radioObj: {},
		init: function(){
			var radioEls = {};
			for (var i=0; i<toggleRadio.$el.length; i++) {
				var name = toggleRadio.$el.eq(i).attr("name");
				var $radios = $("input[type='radio'][name='"+ name +"']");

				if(radioEls.hasOwnProperty(name)){
					continue;
				}else{
					radioEls[name] = $radios;
				}
				
				$radios.each(function(){
					var $this = $(this);
					var $siblings = $radios.not($this);

					$this.attr("data-active-target") && $siblings.attr("data-inactive-target", $this.attr("data-active-target"));
					$this.attr("data-required-target") && $siblings.attr("data-optional-target", $this.attr("data-required-target"));
				});
			}

			toggleRadio.setRadioObj(radioEls);
			toggleRadio.addEvent();
		},
		setRadioObj: function(els){
			for (var prop in els) {
				toggleRadio.radioObj[prop] = {};
				els[prop].each(function(){
					var $el = $(this);
					var requiredInput = $el.attr("data-required-target") || null;
					var optionalInput = $el.attr("data-optional-target") || null;

					function labelSelector(str){
						if(!str) { return null };
						var strArr = str.split(",");
						var labelArr = strArr.map(function(item){
							return 'label[for="'+ item.replace(/(input#)/g, "").replace(/(\s*)/g, "") +'"]';
						});
						return labelArr.join(",");
					}

					toggleRadio.radioObj[prop][$el.attr("id")] = {
						$this: $el,
						activeTarget: $el.attr("data-active-target") || null,
						inactiveTarget: $el.attr("data-inactive-target") || null,
						requiredLabel: labelSelector(requiredInput),
						requiredInput: requiredInput,
						optionalLabel: labelSelector(optionalInput),
						optionalInput: optionalInput,
						targetDisabled: $el.attr("data-target-disabled") || "false"
					}

					if($el.prop("checked")){
						toggleRadio.setTarget(prop, $el.attr("id"));
					}
				});
			}
		},
		setTarget: function(name, id){
			var targetObj = toggleRadio.radioObj[name][id];

			$(targetObj.activeTarget).show();
			$(targetObj.inactiveTarget).hide();

			$(targetObj.requiredInput).attr("required","required");
			$(targetObj.requiredLabel).find(".require").show();

			$(targetObj.optionalInput).removeAttr("required");
			$(targetObj.optionalLabel).find(".require").hide();

			if(targetObj.targetDisabled == "true") {
				// 20200409 START 구유정 || val 변경
				$(targetObj.requiredInput).removeAttr("disabled").val($(targetObj.requiredInput).val());
				// 20200409 END 구유정 || val 변경
				$(targetObj.optionalInput).attr("disabled", "disabled").val("");
			}
		},
		addEvent: function(){
			toggleRadio.$el.on({
				"change": function(){
					toggleRadio.setTarget($(this).attr("name"), $(this).attr("id"));
				},
				"toggleRadio:check": function(){
					toggleRadio.setTarget($(this).attr("name"), $(this).attr("id"));
				}
			});
		}
	}

	// locale: de/in/cn
	var btbSelector = {
		el: document.querySelector(".btb-selector"),
		name: null,
		value: null,
		dispatchData: null,
		dispatchTarget: null,
		$modal: $("#btb-selector-confirm"),
		// 20200408 START 구유정 || btbSelector.$watchForm 추가
		$watchForm: null,
		// 20200408 END 구유정 || btbSelector.$watchForm 추가
		init: function(){
			// 20200406 START 구유정 || .only-business remove 추가
			if(!btbSelector.el){
				$(step.wrap).find(".only-business").remove();
				return;
			};
			// 20200406 END 구유정 || .only-business remove 추가

			btbSelector.name = btbSelector.el.querySelector("input").getAttribute("name");
			btbSelector.value = btbSelector.el.querySelector("input:checked").getAttribute("value");

			// dispatch: b2b/b2c 변경 시 dispatch 이벤트
			// DE, IN : Product Category selectbox
			// CN : Repair Type 내 Time Schedule selectbox
			var param = btbSelector.name+"="+btbSelector.value;
			btbSelector.dispatchData = JSON.parse(btbSelector.el.getAttribute("data-dispatch-data"));
			btbSelector.dispatchTarget = btbSelector.el.getAttribute("data-dispatch-target");

			$(btbSelector.dispatchTarget).trigger(
				btbSelector.dispatchData.type, {
					dataUrl: btbSelector.dispatchData.url,
					$originTarget: $(btbSelector.el).find("input"),
					// 20200408 START 구유정 || $checkedTarget 추가
					$checkedTarget: $(btbSelector.el).find("input:checked")
					// 20200408 END 구유정 || $checkedTarget 추가
				}
			);

			// 20200408 START 구유정 || switch 분리
			switch (btbSelector.dispatchTarget) {
				case ".comboboxForm":
					$(btbSelector.dispatchTarget).find('select').attr("data-param", param).data("param", param);	
					break;
				case "#repairTypeForm":
					// 
					break;
				// default:
				// 	break;
			}
			// 20200408 END 구유정 || switch 분리
			
			// 20200408 START 구유정 || CN CASE 추가
			if(step.countrycode == "cn"){
				btbSelector.$watchForm = $("#step_select_product, #step_repair_type");
			}
			// 20200408 END 구유정 || CN CASE 추가

			// 퍼블 확인용
			$(btbSelector.dispatchTarget).append('<input type="hidden" name="'+ btbSelector.name +'" value='+ btbSelector.value +'>');
			// 개발요청
			$("form#stepSelectProduct").append('<input type="hidden" name="'+ btbSelector.name +'" value='+ btbSelector.value +'>');

			btbSelector.addEvent();

			// 20200408 START 구유정 || btbSelector.watchFormChange() 추가
			btbSelector.$watchForm && btbSelector.watchFormChange();
			// 20200408 END 구유정 || btbSelector.watchFormChange() 추가
		},
		// 20200408 START 구유정 || btbSelector.watchFormChange, btbSelector.checkFormChange 추가
		watchFormChange: function(){
			btbSelector.$watchForm.attr("data-is-form-changed", false);
			btbSelector.$watchForm.one("change", "input, select, textarea", function(event){
				$(event.delegateTarget).attr("data-is-form-changed", true);
			});
		},
		checkFormChange: function(){
			var status = false;

			// GP: not CN
			if(step.countrycode != "cn"){
				status = document.getElementById("modelNumber_hidden").value != "";
			}

			// CN
			if(step.countrycode == "cn"){
				status = $("[data-is-form-changed='true']").length > 0;
			}

			return status;
		},
		// 20200408 END 구유정 || btbSelector.watchFormChange, btbSelector.checkFormChange 추가
		addEvent: function(){
			$(btbSelector.el).on("click", "input[type='radio']", function(e){
				var $this = $(this);

				if(btbSelector.checkFormChange()){
					// radio value 변경X && modal show
					e.preventDefault();
					$this.addClass("pause").siblings().removeClass("pause");
					btbSelector.$modal.modal("show");
				}else if($(this).val() != btbSelector.value){
					// radio value 변경O && 전체 폼 reset
					btbSelector.value = $(this).val();
					step.resetStepForm();
				}
			});

			// radio value 변경 후
			$(btbSelector.el).on("change", "input[type='radio']", function(e){
				var $this = $(this);
				var param = btbSelector.name+"="+$this.val();

				$this.trigger("blur.base");
				
				// 20200408 START 구유정 || switch 분리
				switch (btbSelector.dispatchTarget) {
					case ".comboboxForm":
						$(btbSelector.dispatchTarget).find('select').attr("data-param", param).data("param", param);	
						break;
					case "#repairTypeForm":
						$(btbSelector.dispatchTarget).trigger(btbSelector.dispatchData.type, {
							dataUrl: btbSelector.dispatchData.url,
							$originTarget: $(btbSelector.el).find("input"),
							$checkedTarget: $(btbSelector.el).find("input:checked")
						});
						break;
					// default:
					// 	break;
				}
				// 20200408 END 구유정 || switch 분리
				
				// 퍼블 확인용
				$(btbSelector.dispatchTarget).find('input[name="' + btbSelector.name + '"]').val( $this.val() );
				// 개발요청
				$("form#stepSelectProduct").find('input[name="' + btbSelector.name + '"]').val( $this.val() );

				// 20200408 START 구유정 || btbSelector.watchFormChange() 추가
				btbSelector.$watchForm && btbSelector.watchFormChange();
				// 20200408 END 구유정 || btbSelector.watchFormChange() 추가
			});

			// radio value 변경 전, modal submit btn click
			btbSelector.$modal.on("submit", "#btbSelectorForm", function(e){
				e.preventDefault();

				step.resetStepForm();
				btbSelector.$modal.modal("hide");

				$(btbSelector.el).find("input[type='radio'].pause")
					.removeClass("pause").prop("checked",true)
					.trigger("change");
				btbSelector.value = $(btbSelector.el).find("input[type='radio']:checked").val();
			})
		}
	}

	step.init();
	toggleRadio.init();
	btbSelector.init();

});